import st from "lib/utils/index";
import { ReviewDecorator } from "lib/decorators/index";
import BaseRepository from "./BaseRepository";

export const serializeReview = (data, initialData) => data;

export default new (class ReviewsRepository extends BaseRepository {
  findAll(params = {}) {
    const bucket = this.getBucket("reviews.index");
    const request$ = this.api.get(`/reviews`, { params }).map((response) => ({
      records: st.api
        .dejsonapinize(response.data.data, response.data.included)
        .map((review) => new ReviewDecorator(review)),
      meta: response.data.meta,
    }));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }

  find(id) {
    return this.api
      .get(`/reviews/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((review) => new ReviewDecorator(review));
  }

  update(data, initialData) {
    return this.api
      .put(`/reviews/${data.id}`, {
        review: serializeReview(data, initialData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((review) => new ReviewDecorator(review));
  }

  delete(id) {
    return this.api.delete(`/reviews/${id}`);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/ReviewsRepository.js